import {ActionHandlerBase} from "../action-handler-base";
import {ILoginActionPayload} from "@sparkware/uc-sdk-core";

export class LoginActionHandler extends ActionHandlerBase<ILoginActionPayload> {
    async handle(payload: ILoginActionPayload): Promise<void> {
        if(payload?.actionData?.dontWaitForUserAction) {
            await this.services.user.waitForAutoLogin();
            if (!this.services.user.isAuthorized) {
                //on purpose we don't await here in order to immediately return the control to the caller
                this.services.user.openLogin();
            }
        } else {
            if(!await this.services.user.ensureUserIsLoggedIn('LoginActionHandler')) {
                throw new Error('User canceled the login');
            }
        }

    }

}